var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field"},[_c('div',{staticClass:"content"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":require("@/img/_bar1.png")}})]),_c('a',{attrs:{"href":"https://www.lottery.gov.cn/","target":"_blank"}},[_c('img',{attrs:{"src":require("@/img/_bar2.png")}})])])])
}]

export { render, staticRenderFns }